module.exports = __webpack_public_path__ + "media/images/athletes/2816-55b4e9f4eafaa1e86a99bc8de51876a4.png";